<template>
  <div class="developer-information">
    <div class="developer-information-title">
      <span>开发者信息</span>
      <img src="@/assets/images/avatar.png">
    </div>
    <div class="developer-information-detail">
      <img
        class="developer-information-developperImg"
        :src="developerImage"
        alt=""
      >
      <div class="developer-information-info">
        <div class="developer-information-name">
          {{ developerInfoVO.name }}
        </div>
        <div class="developer-information-num">
          已上架应用数量：{{ developerInfoVO.sum }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    developerInfoVO: {
      type: Object,
      default: ()=>({}),
    },
  },
  data(){
    return {
      defaultImg: require('@/assets/images/developper.png'),
    };
  },
  computed: {
    developerImage(){
      return this.developerInfoVO?.img??this.defaultImg;
    },
  },
};
</script>
<style lang='less' scoped>
  .developer-information{
    border-radius: 8px 8px 8px 8px;
    position: fixed;
    right: 20px;
    top: 130px;
    width: 306px;
    &-title{
      background: #eff5ff;
      height: 52px;
      display: flex;
      align-items: center;
      padding-left: 20px;
      font-weight: bold;
      font-size: 18px;
      color: #333;
      position: relative;
      img{
        width: 82px;
        height: 79px;
        position: absolute;
        top: -15px;
        right: 20px;
      }
    }
    &-detail{
      padding: 20px;
      background: #fff;
      display: flex;
      align-items: flex-start;
    }
    &-name{
      font-size: 18px;
      color: #333;
      font-weight: bold;
      margin-bottom: 6px;
    }
    &-developperImg{
      height: 86px;
      width: 86px;
    }
    &-info{
      padding-left: 16px;
    }
    &-num{
      font-size: 14px;
      color: #333;
    }
  }
</style>